import React from "react";
import { Snackbar, Alert } from "@mui/material";
import { useSnackbarStore } from "../stores/useSnackbarStore";

const GlobalSnackbar: React.FC = () => {
  const { isOpen, message, type, closeSnackbar } = useSnackbarStore();

  return (
    <Snackbar
      open={isOpen}
      autoHideDuration={3000}
      onClose={closeSnackbar}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert onClose={closeSnackbar} severity={type} sx={{ width: "100%" }}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export default GlobalSnackbar;
